import { useState } from 'react'
import { FileUpload } from '../../../shared/ui'
import { splitOversized } from '../../../shared/lib/uploadLimits'
import { Disclosure } from './Disclosure'

interface Props {
  files: File[]
  onChange: (files: File[]) => void
  open: boolean
  onToggle: () => void
}

/**
 * Files on a sign-off, collapsed like the comment. Staged here and uploaded on submit — the
 * sheet is one confirmation, not a stream of requests while the worker is still deciding.
 */
export function FilesDisclosure({ files, onChange, open, onToggle }: Props) {
  const [sizeError, setSizeError] = useState<string | null>(null)

  const label = files.length
    ? `Dateien hinzufügen (${files.length})`
    : 'Dateien hinzufügen'

  return (
    <Disclosure label={label} open={open} onToggle={onToggle}>
      <FileUpload
        value={files}
        onChange={(next) => {
          const { accepted, message } = splitOversized(next)
          setSizeError(message)
          onChange(accepted)
        }}
      />
      {sizeError && <p className="mt-1 text-xs text-red-500">{sizeError}</p>}
    </Disclosure>
  )
}
